class SmidImageSlideshow extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.index = 0;
    this.querySelector('[data-prev]')?.addEventListener('click', () => this.show(this.index - 1), { signal });
    this.querySelector('[data-next]')?.addEventListener('click', () => this.show(this.index + 1), { signal });
    this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.show(index), { signal }));
    this.addEventListener('keydown', (event) => {
      const next = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 }[event.key];
      if (next !== undefined) { event.preventDefault(); this.show(next); }
    }, { signal });
    this.addEventListener('pointerdown', (event) => {
      if (event.isPrimary && event.pointerType !== 'mouse' && !event.target.closest('button')) {
        this.gesture = { x: event.clientX, y: event.clientY, id: event.pointerId };
      }
    }, { signal });
    this.addEventListener('pointerup', (event) => {
      const start = this.gesture;
      this.gesture = null;
      if (!start || event.pointerId !== start.id) return;
      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.show(this.index + (dx < 0 ? 1 : -1));
    }, { signal });
    this.addEventListener('pointercancel', () => { this.gesture = null; }, { signal });
    this.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.indexOf(event.target.closest('[data-slide]'));
      if (index !== -1) this.show(index);
    }, { signal });
    this.show(0, false);
    this.classList.add('is-ready');
  }
  show(index, announce = true) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      slide.hidden = i !== this.index;
      if (i === this.index) slide.querySelector('img')?.setAttribute('loading', 'eager');
    });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    if (announce) this.querySelector('[data-status]').textContent = 'Afbeelding ' + (this.index + 1) + ' van ' + this.slides.length;
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('smid-image-slideshow')) customElements.define('smid-image-slideshow', SmidImageSlideshow);

// Horizon scrolls a page wrapper; the review app otherwise tries to scroll window.
window.addEventListener('click', (event) => {
  const reviewLink = event.target.closest('.sma-hero__rating [data-repocean-open-reviews]');
  const reviews = document.querySelector('.sma-reviews');
  if (!reviewLink || !reviews) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  reviews.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  const heading = reviews.querySelector('h2');
  if (heading) { heading.tabIndex = -1; heading.focus({ preventScroll: true }); }
}, { capture: true });

// Carry an explicit solution enquiry into the existing, protected contact form.
const enquiry = new URLSearchParams(location.search).get('oplossing');
if (['Gordijnen', 'Traprenovaties', 'Kitwerk', 'Plinten'].includes(enquiry)) {
  const message = document.querySelector('textarea[name="contact[body]"]');
  if (message && !message.value.trim()) message.value = 'Ik ontvang graag advies over ' + enquiry.toLowerCase() + '.';
}

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.sma-mobile-nav[open]').forEach((menu) => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', (event) => {
  const cookieLink = event.target.closest('[data-cookie-preferences]');
  if (cookieLink && window.privacyBanner?.showPreferences) {
    event.preventDefault();
    window.privacyBanner.showPreferences().catch(() => { location.href = cookieLink.href; });
  }
  document.querySelectorAll('.sma-mobile-nav[open]').forEach((menu) => {
    if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
  });
});
